import { observer } from 'mobx-react-lite';
import { X, CheckCircle, AlertCircle } from 'lucide-react';
import { toast } from './ToastStore';

export { toast } from './ToastStore';

export const ToastContainer = observer(() => {
  if (toast.items.length === 0) return null;

  return (
    <div
      aria-live="polite"
      aria-label="Notifications"
      className="fixed bottom-4 right-4 z-50 flex flex-col gap-2 pointer-events-none"
    >
      {toast.items.map((item) => (
        <div
          key={item.id}
          role="status"
          className={`flex items-center gap-2 px-4 py-2.5 rounded-lg shadow-lg text-sm font-medium pointer-events-auto animate-slide-in-from-right ${
            item.variant === 'success'
              ? 'bg-gray-900 text-white border border-gray-700'
              : 'bg-red-900 text-white border border-red-700'
          }`}
        >
          {item.variant === 'success' ? (
            <CheckCircle className="w-4 h-4 text-green-400 shrink-0" />
          ) : (
            <AlertCircle className="w-4 h-4 text-red-300 shrink-0" />
          )}
          <span>{item.message}</span>
          <button
            onClick={() => toast.remove(item.id)}
            aria-label="Dismiss"
            className="ml-1 text-gray-400 hover:text-white"
          >
            <X className="w-3.5 h-3.5" />
          </button>
        </div>
      ))}
    </div>
  );
});
